import { PageLayout } from "@/ui/components/common";
import {
  HeroSection,
  FeaturesSection,
  StorySection,
  CtaSection,
  ContactSection,
  LandingFooter,
} from "@/ui/components/landing";

/**
 * 首頁
 * 顯示 Mayi AI 的登陸頁內容
 */
export function HomePage() {
  return (
    <PageLayout
      variant="landing"
      showSidebar={false}
      padding={false}
      showFooter={false}
    >
      <main className="bg-warm-beige">
        <HeroSection />
        <FeaturesSection />
        <StorySection />
        <CtaSection />
        <ContactSection />
        <LandingFooter />
      </main>
    </PageLayout>
  );
}
